module.exports = __webpack_public_path__ + "static/media/left.a0b3fbbf.jpg";